import {noReportIntervalHour} from './components/Profile';
import {noReportAt} from './components/Profile';

export default class Storage {
    static saveJwtResponseData(data) {
        this._setToken(data.token);
        this._setEmail(data.user.email);
        this._setIsStaff(data.user.is_staff);
        this._setId(data.user.id);
    }

    static saveClientInfo(info) {
        localStorage.setItem('self_measurement_of_package_dimensions', info.self_measurement_of_package_dimensions);
        if (info.report_interval_hour) {
            localStorage.setItem('report_interval_hour', info.report_interval_hour);
        } else {
            localStorage.setItem('report_interval_hour', noReportIntervalHour);
        }
        if (info.report_at) {
            localStorage.setItem('report_at', info.report_at);
        } else {
            localStorage.setItem('report_at', noReportAt);
        }
    }

    static getToken = () => localStorage.getItem('token');
    static _setToken = (token) => localStorage.setItem('token', token);
    static getEmail = () => localStorage.getItem('email');
    static isHumAid = () => this.getEmail() === 'humaid@velox.com';
    static _setEmail = (email) => localStorage.setItem('email', email);
    static getIsStaff = () => JSON.parse(localStorage.getItem('is_staff'));
    static _setIsStaff = (isStaff) => localStorage.setItem('is_staff', isStaff);
    static _setId = (id) => localStorage.setItem('id', id);
    static getId = () => JSON.parse(localStorage.getItem('id'));
    static getReportIntervalHour = () => localStorage.getItem('report_interval_hour');
    static setReportIntervalHour = (hour) => localStorage.setItem('report_interval_hour', hour);
    static getReportAt = () => localStorage.getItem('report_at');
    static setReportAt = (time) => localStorage.setItem('report_at', time);
    static clear = () => localStorage.clear();

    static getSelfMeasurementOfPackageDimensions = () => JSON.parse(localStorage.getItem('self_measurement_of_package_dimensions'));
}

